import styled from "styled-components";

export const LoginPhoneStyled = styled.div`
  padding: 24px;
  border-radius: 18px;
  background-color: #f6f7f9;
  max-width: 354px;
  min-width: 320px;
  min-height: ${(props) => (props.loginStep === 2 ? "70vh" : " 300px")};
  position: relative;
  height: 94vh;
`;
